/* Festive Cleaning Kit PDP blocks: gift-box pop-out and before/after slider. */
(function () {
  if (window.__fkPdpInit) return;
  window.__fkPdpInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canObserve = 'IntersectionObserver' in window;

  function initGiftBox(box) {
    if (box.dataset.fkInit) return;
    box.dataset.fkInit = '1';
    if (box.dataset.animate !== 'true' || reduceMotion || !canObserve) return;
    // Arm only once we know we can reveal again, so tiles never stay hidden.
    box.classList.add('fk-box--armed');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        box.classList.add('is-open');
        io.disconnect();
      });
    }, { threshold: 0.35 });
    io.observe(box);
  }

  function initBeforeAfter(frame) {
    if (frame.dataset.fkInit) return;
    frame.dataset.fkInit = '1';
    var range = frame.querySelector('.fk-ba__range');
    var tagBefore = frame.querySelector('.fk-ba__tag--before');
    var tagAfter = frame.querySelector('.fk-ba__tag--after');
    var start = parseFloat(frame.dataset.start) || 70;

    function set(p) {
      p = Math.max(0, Math.min(100, p));
      frame.style.setProperty('--pos', p + '%');
      if (range) range.value = Math.round(p);
      if (tagBefore) tagBefore.style.opacity = p < 18 ? 0 : 1;
      if (tagAfter) tagAfter.style.opacity = p > 82 ? 0 : 1;
    }
    function fromX(x) {
      var r = frame.getBoundingClientRect();
      return ((x - r.left) / r.width) * 100;
    }

    // Touch: only take over once the gesture is clearly horizontal, so vertical swipes scroll the page.
    var dragging = false, decided = false, sx = 0, sy = 0;
    frame.addEventListener('pointerdown', function (e) {
      dragging = true;
      decided = false;
      sx = e.clientX;
      sy = e.clientY;
      frame.classList.remove('is-animating');
      if (e.pointerType === 'mouse') {
        decided = true;
        frame.setPointerCapture(e.pointerId);
        set(fromX(e.clientX));
      }
    });
    frame.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      if (!decided) {
        var dx = Math.abs(e.clientX - sx), dy = Math.abs(e.clientY - sy);
        if (dx < 6 && dy < 6) return;
        if (dy > dx) { dragging = false; return; }
        decided = true;
        try { frame.setPointerCapture(e.pointerId); } catch (err) {}
      }
      set(fromX(e.clientX));
    });
    frame.addEventListener('pointerup', function (e) {
      // A tap (no movement) jumps the split to the tapped point.
      if (dragging && !decided) set(fromX(e.clientX));
      dragging = false;
    });
    frame.addEventListener('pointercancel', function () { dragging = false; });
    if (range) {
      range.addEventListener('input', function () {
        frame.classList.remove('is-animating');
        set(+range.value);
      });
    }
    set(start);

    // One gentle sweep the first time it scrolls into view, so it reads as a slider.
    if (frame.dataset.sweep === 'true' && canObserve && !reduceMotion) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        frame.classList.add('is-animating');
        var low = Math.max(10, start - 40);
        setTimeout(function () { set(low); }, 250);
        setTimeout(function () { set(start); }, 1250);
        setTimeout(function () { frame.classList.remove('is-animating'); }, 2300);
      }, { threshold: 0.5 });
      io.observe(frame);
    }
  }

  // Sticky add-to-cart bar: show price x quantity (theme only shows the unit price).
  var pdpData = null;
  try { pdpData = JSON.parse(document.getElementById('fk-pdp-data').textContent); } catch (e) {}

  function formatMoney(cents) {
    var format = (pdpData && pdpData.moneyFormat) || '₹{{amount_no_decimals}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return whole;
      if (key === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      if (key === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return whole + '.' + parts[1];
    });
  }

  function updateStickyPrice() {
    if (!pdpData || !pdpData.variants) return;
    var current = document.querySelector('#floating-atc .floating-atc__price--current');
    var qtyInput = document.getElementById('floating-qty');
    var variantInput = document.getElementById('floating-variant-id');
    if (!current || !qtyInput) return;
    var id = variantInput ? Number(variantInput.value) : 0;
    var variant = pdpData.variants.filter(function (v) { return v.id === id; })[0] || pdpData.variants[0];
    var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    var label = '<span class="product-price__mrp-label">M.R.P.:</span> ';
    var compare = document.querySelector('#floating-atc .floating-atc__price--compare');
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      current.textContent = formatMoney(variant.price * qty);
      if (compare) compare.innerHTML = label + '<s>' + formatMoney(variant.compare_at_price * qty) + '</s>';
    } else {
      current.innerHTML = label + formatMoney(variant.price * qty);
    }
  }

  // Runs after the theme's own qty/variant handlers (they update the input first).
  ['click', 'input', 'change'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.product-info__qty-btn, #floating-qty, #product-qty, .product-info__select')) {
        setTimeout(updateStickyPrice, 0);
      }
    });
  });

  function initAll(root) {
    (root || document).querySelectorAll('[data-fk-box]').forEach(initGiftBox);
    (root || document).querySelectorAll('[data-fk-ba]').forEach(initBeforeAfter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Theme editor: re-init when the product section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
